import React from 'react';
import { Space, Button, Typography, Divider, Tooltip, Grid } from 'antd';
import { 
    EditOutlined, 
    DeleteOutlined, 
    CheckCircleOutlined, 
    TagOutlined,
    CloseOutlined,
    BankOutlined,
    CalendarOutlined
} from '@ant-design/icons';
import { motion } from 'framer-motion';

const { Text } = Typography;
const { useBreakpoint } = Grid;

export default function BatchActionsBar({ 
    selectedCount, 
    onClear, 
    onBulkDelete, 
    onBulkCategory,
    onBulkStatus,
    onBulkAccount
}) {
    const screens = useBreakpoint();
    const isMobile = !screens.md;

    if (selectedCount === 0) return null;

    return (
        <motion.div
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            style={{
                position: 'fixed',
                bottom: isMobile ? 12 : 24,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1000,
                width: isMobile ? '95%' : 'auto',
                minWidth: isMobile ? 'unset' : '500px'
            }}
        >
            <div style={{
                background: 'rgba(15, 23, 42, 0.9)',
                backdropFilter: 'blur(12px)',
                padding: isMobile ? '8px 12px' : '12px 24px',
                borderRadius: isMobile ? '12px' : '16px',
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2), 0 10px 10px -5px rgba(0, 0, 0, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: isMobile ? 8 : 24
            }}>
                <Space size={isMobile ? 8 : 16}>
                    <div style={{
                        background: '#3b82f6',
                        width: isMobile ? 28 : 32,
                        height: isMobile ? 28 : 32,
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: isMobile ? '12px' : '14px'
                    }}>
                        {selectedCount}
                    </div>
                    {!isMobile && (
                        <Text style={{ color: 'white', fontWeight: 600 }}>
                            Itens selecionados
                        </Text>
                    )}
                </Space>

                <Divider type="vertical" style={{ height: 24, borderColor: 'rgba(255, 255, 255, 0.2)' }} />

                <Space size={isMobile ? 4 : 8}>
                    <Tooltip title="Alterar Categoria">
                        <Button 
                            type="text" 
                            icon={<TagOutlined />} 
                            onClick={onBulkCategory}
                            style={{ color: '#94a3b8', fontWeight: 600, fontSize: isMobile ? '12px' : '14px' }}
                            className="batch-btn"
                        >
                            {!isMobile && 'Categoria'}
                        </Button>
                    </Tooltip>
                    
                    <Tooltip title="Alterar Conta/Banco">
                        <Button 
                            type="text" 
                            icon={<BankOutlined />} 
                            onClick={onBulkAccount}
                            style={{ color: '#94a3b8', fontWeight: 600, fontSize: isMobile ? '12px' : '14px' }}
                            className="batch-btn"
                        >
                            {!isMobile && 'Banco'}
                        </Button>
                    </Tooltip>

                    <Tooltip title="Liquidar Selecionados">
                        <Button 
                            type="text" 
                            icon={<CheckCircleOutlined />} 
                            onClick={() => onBulkStatus('L')}
                            style={{ color: '#10b981', fontWeight: 600, fontSize: isMobile ? '12px' : '14px' }}
                            className="batch-btn"
                        >
                            {!isMobile && 'Liquidar'}
                        </Button>
                    </Tooltip>

                    <Tooltip title="Excluir Selecionados">
                        <Button 
                            type="text" 
                            danger
                            icon={<DeleteOutlined />} 
                            onClick={onBulkDelete}
                            style={{ fontWeight: 600, fontSize: isMobile ? '12px' : '14px' }}
                            className="batch-btn-danger"
                        >
                            {!isMobile && 'Excluir'}
                        </Button>
                    </Tooltip>
                </Space>

                <Divider type="vertical" style={{ height: 24, borderColor: 'rgba(255, 255, 255, 0.2)' }} />

                <Button 
                    type="text" 
                    icon={<CloseOutlined />} 
                    onClick={onClear}
                    style={{ color: '#64748b' }}
                />
            </div>

            <style>{`
                .batch-btn:hover {
                    background: rgba(255, 255, 255, 0.1) !important;
                    color: white !important;
                }
                .batch-btn-danger:hover {
                    background: rgba(239, 68, 68, 0.1) !important;
                }
            `}</style>
        </motion.div>
    );
}
